import React, { useState } from 'react';

const defaultValue = {
  empresas: [],
  loading: false,
  totalElements: 0,
  modal: '',
  search: '',
  page: 0,
  size: 15,
  sort: 'pessoa.nome,asc',
};

export const EmpresaTableContext = React.createContext({});

export const EmpresaTableProvider = (props) => {
  return (
    <EmpresaTableContext.Provider
      value={{
        empresas: useState(defaultValue.empresas),
        loading: useState(defaultValue.loading),
        totalElements: useState(defaultValue.totalElements),
        modal: useState(defaultValue.modal),
        search: useState(defaultValue.search),
        page: useState(defaultValue.page),
        size: useState(defaultValue.size),
        sort: useState(defaultValue.sort),
      }}
    >
      {props.children}
    </EmpresaTableContext.Provider>
  );
};

export const EmpresaTableConsumer = EmpresaTableContext.Consumer;
